export const getEditPosterURL = (hash: string): string => {
  return window.PMW.util.site_url(`posterbuilder/load/${hash}`);
};

/**
 * Rewrites the browser URL to the plain poster-load path without navigating, so a page refresh loads the
 * poster directly instead of re-running whatever flow (AI chat image add, editable-layers conversion) got
 * the editor here.
 */
export const replacePosterLoadUrl = (hashedId: string): void => {
  window.history.replaceState(null, '', getEditPosterURL(hashedId));
};

export const getDuplicatePosterURL = (hash: string): string => {
  return window.PMW.util.site_url(`posterbuilder/copy/${hash}`);
}

export const isInReviewOrGalleryTemplate = (): boolean => {
  return !!window.posterEditor?.whiteboard?.isGalleryTemplate() || !!window.posterEditor?.config?.isInReview;
};
